import React, { memo, useState, useEffect } from 'react';
import { Theme } from '@material-ui/core';
import { useIntl } from 'react-intl';
import { withStyles, WithStyles, createStyles } from '@material-ui/core/styles';
import { ActionModal } from '../../../components/Modal';
import { TextField, PasswordTextField } from '../../../components/TextField';
import { validatePassword } from '../../../helper/validation';

const styles = (theme: Theme) => {
  return createStyles({
    root: {},
  });
};

export interface IChangePasswordModalProps extends WithStyles<typeof styles> {
  open: boolean;
  handleClose: () => void;
  handleRestMemberPassword: (data: any) => void;
  selectMember: any;
  selectedMember: any;
}

const ChangePasswordModal = ({
  classes,
  open,
  handleClose,
  handleRestMemberPassword,
  selectMember,
  selectedMember,
}: IChangePasswordModalProps) => {
  const [password, setPassword] = useState({ error: false, value: '' });
  const intl = useIntl();

  useEffect(() => {
    handleClose();
  }, [selectMember.loading]);

  const passwordOnChange = (e: { target: { value: string } }) => {
    const error = validatePassword(e.target.value);
    setPassword({ value: e.target.value, error });
  };

  const _validate = () => {
    let isValidate = true;

    if (!password.value || password.error) {
      isValidate = false;
      setPassword({ ...password, error: true });
    }

    return isValidate;
  };
  const onClickActionButton = () => {
    if (_validate()) {
      const memberData = {
        _id: selectedMember?._id,
        password: password.value,
      };
      handleRestMemberPassword(memberData);
    }
  };
  return (
    <ActionModal
      modalTitle={intl.formatMessage({
        id: 'change_member_password',
      })}
      selectedItem={selectedMember?.profile?.name}
      modalDescription={intl.formatMessage({
        id: 'change_password_member_description',
      })}
      open={open}
      handleClose={handleClose}
      actinButtonLabel={intl.formatMessage({
        id: 'copy_password_and_save',
      })}
      actinButtonOnClick={onClickActionButton}
    >
      <TextField
        id="change-password-email"
        value={selectedMember?.email}
        disabled
      />
      <PasswordTextField
        id="change-password-input"
        placeholder={intl.formatMessage({
          id: 'new_password',
        })}
        onChange={passwordOnChange}
        required
        error={password.error}
        helperText={
          password.error &&
          intl.formatMessage({
            id: 'please_insert_valid_password',
          })
        }
      />
    </ActionModal>
  );
};

export default memo(withStyles(styles)(ChangePasswordModal));
